import React from 'react'
import './Breakdrum.css'

function Breakdrum(props) {
  return (
    <div className='breakdrum_container'>
        <h2>{props.title}<hr/></h2>
        <p>{props.para}</p>
    </div>
  )
}

export default Breakdrum